import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=2453f10c"
import script from "../../controllers/driver/driver-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/driver/driver-list.js?vue&type=script&lang=js&external"
import style0 from "./DriverList.vue?vue&type=style&index=0&id=2453f10c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports